import React, { useState } from 'react'
// @ts-ignore
import useCountDown from 'react-countdown-hook';

import './index.css'
import bindPhoneImg from './img/bind-phone.png'
import { checkPhoneNumber } from '@util/common.util';
import { Toast } from 'antd-mobile-v2';
import { sendVerificationCode, setLocalUser } from '@service/user.service';
import { saveTelephone4Person } from '@api/user.api';
import { useSelector } from 'react-redux';
import { RootState } from '@store/index';
import { useHistory } from 'react-router';
// import { sendVerificationCode } from '@api/user.api';

const initialTime = 60 * 1000; // initial time in milliseconds, defaults to 60000
const interval = 1000; // interval to change remaining time amount, defaults to 1000

export default function BindPhone() {
  const [phoneNo, setPhoneNo] = useState('');
  const [code, setCode] = useState('');
  const personId = useSelector<RootState>((state)=>{return state.user.personId}) as number;
  const history = useHistory()
  const [countDown, { start, reset }] = useCountDown(initialTime, interval);
  const onClickGetCode = async () => {
    // const res = await sendVerificationCode();
    if (!!countDown) { return; }
    else {
      if (checkPhoneNumber(phoneNo)) {
        start();
        const res = await sendVerificationCode(phoneNo);
        if (!res.verificationCode) {
          reset();
          if (res.returnCode === '0') {
            Toast.info('您的手机号已经认证过了哦', 1);
          }
          if (res.returnCode === '2') {
            Toast.info('获取验证码过于频繁', 1);
          }
          if (!res.returnCode) {
            Toast.info('获取验证码异常，请稍后重试', 1);
          }
        }
      } else {
        Toast.info('请输入正确的手机号', 1);
      }

    }
  }
  const onClickSubmit = async () => {
    if (!checkPhoneNumber(phoneNo)) {
      Toast.info('手机号格式错误');
      return;
    }

    if (code.length !== 4) {
      Toast.info('验证码格式错误');
      return;
    }
    let res = await saveTelephone4Person({
      personId,
      telephone: phoneNo,
      verificationCode: code,
    });

    const MESSAGE_MAP = {
      '0': '手机号码绑定成功',
      '1': '验证码错误',
      '2': '验证码过期',
      '3': '手机号码修改成功',
      '4': '该手机号已被绑定',
    } as any;
    const errorCode = res.returnCode;
    Toast.info(MESSAGE_MAP[errorCode] || '绑定手机失败');
    if (errorCode === '0' || errorCode === '3') {
      let localUser = JSON.parse(window.localStorage.user);
      localUser.mobile = phoneNo;
      setLocalUser(localUser);
      history.push('/register')
    }
  }
  return (
    <div className="bind-telephone-body">
      <header ng-if="'worker' == pl_user">
        <div className="bind-telephone-header">
          <div className="bind-telephone-img">
            <img className="bind-telephone fl" src={bindPhoneImg} alt="" />
          </div>
          <div className="bind-telephone-text">
            <label className="top">绑定手机号码</label>
            <label className="bottom">及时收到客户预约通知</label>
          </div>
        </div>
      </header>
      <div>
        <input type="tel" className="telephone" maxLength={11} placeholder="请输入手机号" value={phoneNo} onChange={(event) => { setPhoneNo(event.target.value) }} />
      </div>

      <div className="code-line-wrapper">
        <input type="tel" className="verificationCode fl" maxLength={4} placeholder="请输入验证码" value={code} onChange={(event) => { setCode(event.target.value) }} />
        <div className={`getVerificationCode ${!!countDown?'disabled':''}`} onClick={onClickGetCode}>{`获取验证码${!!countDown ? `(${countDown / 1000})` : ``}`}</div>
      </div>

      <div>
        <div className="submit" onClick={onClickSubmit}>确 定</div>
      </div>

    </div>

  )
}
